export function chunks<T>(array: Array<T>, chunkSize: number) {
  const R = [];
  for (var i = 0; i < array.length; i += chunkSize)
    R.push(array.slice(i, i + chunkSize));
  return R;
}
